import React from 'react';

/** État vide harmonisé (listes, tableaux). */
export default function ReceptionEmptyState({ icon, title, description, action }) {
  return (
    <div className="recv-empty-state" role="status">
      {icon ? <div className="recv-empty-state__icon" aria-hidden>{icon}</div> : null}
      {title ? <p className="recv-empty-state__title mb-1">{title}</p> : null}
      {description ? <p className="recv-empty-state__desc mb-0">{description}</p> : null}
      {action ? <div className="recv-empty-state__action mt-3">{action}</div> : null}
    </div>
  );
}
